import { IIconProps, IIconSize } from "src/components/icons/IconProps";
const SvgInbox = (props: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    height={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke={props.color ? props.color : "#494949"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M22 12h-6l-2 3h-4l-2-3H2"
    />
    <path
      stroke={props.color ? props.color : "#494949"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11"
    />
  </svg>
);
export default SvgInbox;
